<template>
  <section class="p-2">

    <div class="d-flex justify-content-between">
      <h2>Scripts</h2>

      <b-button-group>

        <b-button variant="primary" @click="getCodes()">
          Reload
        </b-button>

        <b-button variant="success" @click="editCode()">
          Add
        </b-button>
      </b-button-group>
    </div>

    <div class="d-flex flex-column flex-md-row flex-wrap">
      <div class="card  mb-3 mr-md-3" v-for="c of codes" :key="c.id" style="max-width: 400px">
        <div class="card-header">{{ c.purpose }}</div>


        <div class="card-footer d-flex justify-content-end">
          <b-btn-group>
            <b-button variant="success" @click="editCode(c)">
              Edit
            </b-button>
            <b-button variant="danger" @click="deleteCode(c)">
              Delete
            </b-button>
          </b-btn-group>
        </div>
      </div>
    </div>
    <b-modal id="edit-code" title="Edit Script" @ok="saveCode">
        <div id="editor"></div>
    </b-modal>
  </section>
</template>
<script>
import axios from "axios";

export default {
  name: "discounts",
  components: {},
  data() {
    return {
      codes: [],
      discountTypes: ['FIXED', 'PERCENT'],
      newCode: {
        script: `class Script {
          def execute(){
          }
        }`,
        purpose: 'ORDER'
      },
      code: {
        brand: {
          id: null
        }
      }
    }
  },
  computed: {},
  methods: {
    async editCode(c) {
      let source = Object.assign({}, (c || this.newCode));
      this.code = Object.assign({}, source)
      this.$bvModal.show('edit-code')
      console.info(this.code, c, this.newCode)

      setTimeout(() => {
        var editor = window.ace.edit("editor");
        editor.setTheme("ace/theme/github_dark");
        editor.session.setMode("ace/mode/groovy");
        editor.setValue(this.code.script)
      }, 300)
    },
    async deleteCode(c) {
      await axios.delete(`/api/super-admin/script/${c.id}`)
      await this.getCodes()
    },
    async saveCode() {
      var editor = window.ace.edit("editor");
      this.code.script = editor.getValue()
      await axios.post(  `/api/super-admin/script/${this.code.id || ''}`, this.code)
      await this.getCodes()
      this.$bvModal.hide('edit-code')
    },
    async getCodes() {
      this.codes = (await axios.get(`/api/super-admin/script`)).data
    }
  },
  async created() {
    await this.getCodes()
  },
}
</script>
<style>
#editor {
  height: 300px;
  width: 100%;
}
</style>